/**
 * Minimal in-app navigation memory: which internal path the user was on
 * before the current one. Powers the /try "back to where you came from"
 * button — present only for in-app arrivals (tools pages, /features, …),
 * absent on direct browser access. Module state resets on full page load,
 * which is exactly the semantics we want.
 */
let previous: string | null = null;
let current: string | null = null;

export function recordPath(pathname: string) {
  if (pathname !== current) {
    previous = current;
    current = pathname;
  }
}

/** The in-app path visited before the current one, or null. */
export function previousPath(): string | null {
  return previous;
}

/**
 * The in-app path the user was on before `pathname`. Safe to call during the
 * first render of the `pathname` route: at that moment the tracker (an
 * effect) hasn't recorded `pathname` yet, so `current` still holds the
 * page navigated FROM; after the tracker runs, `previous` holds it.
 */
export function pathBefore(pathname: string): string | null {
  if (current && current !== pathname) return current;
  return previous;
}
